(() => {
  const header = document.querySelector('#site-header');
  if (!header) return;
  if (header.dataset.autoLogoSwitch !== 'true') return;

  const deskImg = document.querySelector('#logo .js-logo--desktop');
  const mobImg  = document.querySelector('#logo .js-logo--mobile');

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  function parseColorToRGB(color) {
    const el = document.createElement('div');
    el.style.color = color;
    document.body.appendChild(el);
    const rgb = getComputedStyle(el).color;
    document.body.removeChild(el);
    const m = rgb.match(/\d+/g);
    return m ? [parseInt(m[0], 10), parseInt(m[1], 10), parseInt(m[2], 10)] : [0, 0, 0];
  }

  function luminance([r, g, b]) {
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function getHeaderTextColor() {
    // uses what theme decided for header
    return (
      getComputedStyle(header).getPropertyValue('--color-text-header').trim() ||
      getComputedStyle(header).getPropertyValue('--color-text-header-absolute').trim() ||
      getComputedStyle(header).color ||
      '#000'
    );
  }

  function setLogo(useLightLogo) {
    const d = useLightLogo ? header.dataset.logoLight : header.dataset.logoDark;
    const m = useLightLogo ? header.dataset.logoLightMobile : header.dataset.logoDarkMobile;

    // updates both so it wont fail in breakpoint
    if (deskImg && d) deskImg.src = d;
    if (mobImg && m) mobImg.src = m;
  }

  function decideAndSwap() {
    const textLum = luminance(parseColorToRGB(getHeaderTextColor()));
    const isLightText = textLum > 0.6;

    setLogo(isLightText);
  }

  let ticking = false;
  const onUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      decideAndSwap();
      ticking = false;
    });
  };

  const mo = new MutationObserver(onUpdate);
  mo.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });

  decideAndSwap();
  window.addEventListener('scroll', onUpdate, { passive: true });
  window.addEventListener('resize', onUpdate);
  setTimeout(decideAndSwap, 50);
  setTimeout(decideAndSwap, 250);
})();
